export const CasualLeaveEN = {
    casualLeave: {
        edit: {
            type: "Select leave type",
            dateDuplicate: "The same type cannot have duplicate dates!"
        },
        breadcrumb: {
            year: "Casual Leave Information",
            month: "Casual Leave",
            personnel: "CASUAL LEAVE INFORMATION"
        },
        subTitle: {
            year: "Annual Leave",
            month: "Monthly Leave from",
            showAllUser : "Show all employees",
        },
        header: {
            generalInformation: "General Information",
            history: "History",
            personnel: "Personnel Information",
            year: "Annual Leave",
            month: "Monthly Leave",
            detail: "Detail"
        },
        action: {
            type: {
                year: "By Year",
                month: "By Month"
            },
            recalculate: "Re Calculate",
            updateLeave: "Edit Leave Directly"
        },
        word: {
            to: "to"
        },
        label: {
            employee: {
                name: "Full Name",
                code: "Code"
            },
            status: "Status",
            departmentName: "Department",
            jobPositionName: "Job Position",
            jobTitleName: "Job Title",
            balanceTotal: "Total Balance",
            fromDate:"From Date",
            type: "Type",
            leaves: "Amount",
            updateLeave: "Update leave",
            leave: {
                total: "Total",
                expired: "Expired",
                used: "Used",
                balance: "Balance"
            },
            totalLeave: "Total Leave",
            accumulationLeave: "Accumulation Leave",
            seniorityLeave: "Seniority Leave",
            annualLeave: "Annual Leave",
            advancedLeave: "Advanced Leave",
            year: "Year",
            month: "Month",
            amount: "Amount",
            date: "Date",
            reason: "Reason",
            expiredDate: "Expired Date"
        },
        description: {
            updateLeave: "It is recommended to update leave at the start of the period"
        },
        value: {
            reason: {
                create: {
                    annual: "Add annual leave",
                    seniority: "Add seniority leave",
                    accumulation: "Add accumulation leave",
                    accumulation_expired: "Expired Accumulated Leave",
                },
                update: {
                    annual: "Edit annual leave",
                    seniority: "Edit seniority leave",
                    accumulation: "Edit accumulation leave",
                    used: "Edit used leave"
                },
                delete: {
                    accumulation_expired: "Remove accumulation leave",
                    application_leave: "Remove application leave"
                }
            },
            working: {
                Working: "Working",
                Resignation: "Resignation",
                Waiting: "Waiting",
                Droptemp: "Drop temp",
            },
            type: {
                annual: "Annual Leave",
                seniority: "Seniority Leave",
                accumulation: "Accumulation Leave",
                used: "Used Leave"
            }
        },
        message: {
            required: {
                fromDate: "Date is required",
                leave: "Amount is required",
                type: "Type is required"
            }
        },
        unit: {
            leave: {
                day: "day"
            }
        },
        notify:{
            calEmployee: "Please wait a few minutes for the system to recalculate annual leave for employees"
        }
    }
}
